import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button } from './ui'

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const dismissed = localStorage.getItem('yowo-privacy-notice-dismissed')
    if (!dismissed) {
      setShowBanner(true)
    }
  }, [])

  const handleDismiss = () => {
    localStorage.setItem('yowo-privacy-notice-dismissed', 'true')
    setShowBanner(false)
  }

  if (!showBanner) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 sm:p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto bg-slate-900/95 dark:bg-slate-950/95 backdrop-blur-md text-white rounded-2xl shadow-modern-lg border border-slate-700/50 px-4 py-3 sm:px-6 sm:py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-sm text-slate-300 flex-1">
            We use essential browser storage for sign-in and preferences, and collect limited operational scan data.{' '}
            <Link to="/privacy" className="text-blue-400 hover:text-blue-300 underline">
              Learn more
            </Link>
          </p>
          <div className="flex gap-2 shrink-0">
            <Button variant="primary" size="sm" onClick={handleDismiss}>
              Got it
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent
